<app-leveltwo [videos]="true" [notices]="true" [pageName]="'Disaster Relief(Misfortune and Calamity)'">
  <div heading="General Info" class="General">
    <h3>{{'DisasterRelief.PageTitle'|translate}}</h3>

    <h4>{{'DisasterRelief.Misfortune'|translate}}</h4>

    <p [innerHTML]="'DisasterRelief.youmayv4'|translate"></p>

    <p [innerHTML]="'DisasterRelief.ForQuestions'|translate"></p>

    <h4>{{'DisasterRelief.Prop19'|translate}}</h4>

    <p>{{'DisasterRelief.inaddition'|translate}} <a routerLink="/homeowners/proposition-19">{{'DisasterRelief.Prop19link'|translate}}</a> {{'DisasterRelief.page'|translate}}</p>

    <p [innerHTML]="'DisasterRelief.formorev2'|translate"></p>
    <p>{{'DisasterRelief.foradditional'|translate}}<a href="https://www.boe.ca.gov/proptaxes/disaster-relief.htm" target="_blank">{{'DisasterRelief.boelink'|translate}}</a>{{'DisasterRelief.website'|translate}}</p>
    <h4>{{'DisasterRelief.IfyouhavereceivedHeader'|translate}}</h4>
    <p [innerHTML]="'DisasterRelief.IfyouhavereceivedText'|translate"></p>

    <!--
    <button type="button" class="btn btn-primary">{{'DisasterRelief.application'|translate}}</button>
    <br><br>
    <button type="button" class="btn btn-primary">{{'DisasterRelief.prop50button'|translate}}</button>
    <br><br>
    <button type="button" class="btn btn-primary">{{'DisasterRelief.prop171button'|translate}}</button>
    -->

  </div>
  <app-videos-grid class="Videos" [videos]="videos"></app-videos-grid>
  <!-- <app-pdf-url-row class="Notices" [notices]="notices"></app-pdf-url-row> -->

  <div heading="Notices" class="Notices">
    <h3 style="line-height: 130%;">{{'DisasterRelief.Notices'|translate}}</h3>
    <p [innerHTML]="'DisasterRelief.TheOffice'|translate"></p>
    <div class="accordion">
      <accordion [isAnimated]="true" >
        <accordion-group #drop [isOpen]="true">
          <div accordion-heading >
            <span class="dropdown-item clearfix">
              {{'DisasterRelief.Examples'|translate}} <i class="mt-1 float-end" [ngClass]="!drop.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
            </span>
          </div>
          <ul><li><a href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1744994621/Msc/M_C_Notice_of_Assessed_Value_Explanation.pdf" target="_blank">{{'DisasterRelief.NoticeofAssessed'|translate}}</a></li></ul>
        </accordion-group>
      </accordion>
    </div>

    <p>{{'DisasterRelief.Duetothedetailed'|translate}}</p>

    <p>
      <strong>West District Office (Palisades Fire)</strong><br>
      6167 Bristol Parkway, Suite 100<br>
      Culver City, CA 90230<br>
      <strong>(310) 665-5300</strong><br>
    </p>
    <p>
      <strong>East District Office (Eaton Fire)</strong><br>
      1190 Durfee Avenue<br>
      South El Monte, CA 91733<br>
      <strong>(626) 258-6001</strong><br>
    </p>

    <p [innerHTML]="'DisasterRelief.Pleasenote'|translate"></p>
    <p>{{'DisasterRelief.Tosupport'|translate}}</p>


  </div>

  <!-- <tab heading="FAQ">FAQ</tab>
  <tab heading="Forms">Forms</tab> -->
</app-leveltwo>
